<template>
  <footer class="footer">
    <div class="footer__container">
      <div class="footer__content">
    
        <p class="footer__copyright">
          William S. Ness
        </p>
      </div>
      <div class="footer__links">
        <a href="https://github.com/jamme05" target="_blank" rel="noopener noreferrer" class="footer__link" aria-label="GitHub">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
          </svg>
        </a>
        <a href="https://www.linkedin.com/in/william-ask-seglsten-ness-6b4225350" target="_blank" rel="noopener noreferrer" class="footer__link" aria-label="LinkedIn">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
          </svg>
        </a>
        <a href="mailto:info@wask.me" class="footer__link" aria-label="Email">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
            <polyline points="22,6 12,13 2,6"></polyline>
          </svg>
        </a>
      </div>
    </div>
  </footer>
</template>

<script setup>

</script>

<style scoped>
.footer {
  background: var(--bg-darker);
  border-top: 1px solid var(--border-color);
  padding: 2rem 0;
  margin-top: 4rem;
}

.footer__container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.footer__content {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.footer__text,
.footer__copyright {
  font-family: var(--font-mono);
  font-size: 0.9rem;
  color: var(--text-secondary);
  margin: 0;
}

.accent {
  color: var(--neon-cyan);
  font-weight: 600;
}

.footer__links {
  display: flex;
  gap: 1.5rem;
  align-items: center;
}

.footer__link {
  color: white;
  transition: all var(--transition-fast);
  display: flex;
  align-items: center;
}

.footer__link:hover {
  color: var(--text-secondary);
  transform: translateY(-2px);
  filter: drop-shadow(var(--glow-cyan));
}

.footer__link svg {
  width: 24px;
  height: 24px;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .footer__container {
    flex-direction: column;
    text-align: center;
    padding: 0 1rem;
  }

  .footer__content {
    align-items: center;
  }

  .footer__links {
    justify-content: center;
  }
}
</style>
